import React from "react";
import { useLocation } from "react-router-dom";
import Building02 from "@Components/Icons/Building02";
import File02 from "@Components/Icons/File02";
import Globe02 from "@Components/Icons/Globe02";
import Grid01 from "@Components/Icons/Grid01";
import LogoutIcon from "@Components/Icons/Logout";
import Phone01 from "@Components/Icons/Phone01";
import SwitchHorizontal01 from "@Components/Icons/SwitchHorizontal01";
import User01 from "@Components/Icons/User01";
import UserCircle from "@Components/Icons/UserCircle";
import Users01 from "@Components/Icons/Users01";
import Zap from "@Components/Icons/Zap";
import PrimaryNav from "@Components/PrimaryNav";
import GetPath, { GetReplacements } from "@Helpers/GetPath";
import IsPathMatch from "@Helpers/IsPathMatch";
import ProposalNavigation from "@SmartComponents/Proposal/Navigation";
import { AWARDED_CONTRACTS, COUNTRY_SETTINGS, CUSTOMERS, DEVICES, EDIT_SUPPLIER_RESPONSE, INSTANT_DEALS_WON, LOGOUT, MY_ACCOUNT, PARTNERS, ROAMING_DAYS, ROOT, SAVE_SUPPLIER_RESPONSE, SUPPLIERS, TARIFF_PLAN_TYPES, USERS, } from "@Shared/Paths/Admin";
import styles from "./index.module.scss";
const notEditing = (url) => !IsPathMatch(url, EDIT_SUPPLIER_RESPONSE);
const mainRoutes = [
    {
        path: ROOT,
        name: "Dashboard",
        icon: React.createElement(Grid01, { className: styles.icon }),
        exact: true,
        filter: notEditing,
    },
    {
        path: USERS,
        name: "Admin Users",
        icon: React.createElement(UserCircle, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: CUSTOMERS,
        name: "Customers",
        icon: React.createElement(Users01, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: PARTNERS,
        name: "Partners",
        icon: React.createElement(SwitchHorizontal01, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: SUPPLIERS,
        name: "Suppliers",
        icon: React.createElement(Building02, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: DEVICES,
        name: "Devices",
        icon: React.createElement(Phone01, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: AWARDED_CONTRACTS,
        name: "Awarded Contracts",
        icon: React.createElement(File02, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: INSTANT_DEALS_WON,
        name: "Instant Deals Won",
        icon: React.createElement(Zap, { className: styles.icon }),
        filter: notEditing,
    },
    {
        path: COUNTRY_SETTINGS,
        name: "Country Settings",
        icon: React.createElement(Globe02, { className: styles.icon }),
        subNav: [
            { path: ROAMING_DAYS, name: "Roaming/IDD" },
            { path: TARIFF_PLAN_TYPES, name: "Tariff Plan Type" },
        ],
        filter: notEditing,
    },
    {
        path: MY_ACCOUNT,
        name: "My Account",
        icon: React.createElement(User01, { className: styles.icon }),
        filter: notEditing,
    },
];
const bottomRoutes = [
    {
        path: LOGOUT,
        name: "Logout",
        icon: React.createElement(LogoutIcon, { className: styles.icon }),
        exact: true,
        filter: notEditing,
    },
    {
        path: SAVE_SUPPLIER_RESPONSE,
        name: "Save & Exit",
        icon: React.createElement(LogoutIcon, { className: styles.icon }),
        exact: true,
        filter: (url) => IsPathMatch(url, EDIT_SUPPLIER_RESPONSE),
    },
];
export default () => {
    const location = useLocation();
    const filterAndResolve = (routes) => routes
        .filter(({ filter = (path) => !!path }) => filter(location.pathname))
        .map((route) => {
        const replacements = GetReplacements(route.path, location.pathname);
        return { ...route, path: GetPath(route.path, ...replacements) };
    });
    const linkSections = [{ links: filterAndResolve(mainRoutes) }];
    const bottomLinks = filterAndResolve(bottomRoutes);
    let extra = React.createElement(React.Fragment, null), className;
    if (IsPathMatch(location.pathname, EDIT_SUPPLIER_RESPONSE)) {
        extra = (React.createElement(ProposalNavigation, { responseId: location.pathname.replace(/.*?responses\/(.+?)\/edit/, `$1`) }));
        className = styles.setWidth;
    }
    return (React.createElement(PrimaryNav, { variant: "sectioned", linkSections: linkSections, bottomLinks: bottomLinks, className: className }, extra));
};
